/**
 * Web Service handler to retrieve and represent a list of resources
 * at a location or Merchant
 *
 * @class ResourceAvailabilityWS
 */
var ResourceAvailabilityWS = function (parent, resourceWeek) {
  var self = this;

  AbstractWS.apply(this, arguments);

  self.availability = ko.observableArray([]);
  self.baseAvailability = ko.observableArray([]);
  self.name = 'ResourceAvailabilityWS';
  self.resourceId = ko.observable(null);
  self.holidayAdded = ko.observable(false)

  self.unavailability = new ResourceUnavailabilityWS(self.parent);

  self.unavailabilities = self.dependentObservable('unavailabilities', self.unavailability);


	/**
	 * API Endpoint
	 *
	 * @method serviceURL
	 * @return {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/resources/' + self.resourceId() + '/availability';
  });


	/**
	 * Observable method to indicate when a resource availability model has  changed
	 *
	 * @method modelChanged
	 * @return {Boolean}
	 */
  self.modelChanged = ko.computed(function () {
    var i = 0;
    var iAvailLength = self.availability().length;
    var oAvailModel = null;
    var oBaseModel = null;

    // If the availability and baseAvailability lengths are different,
    // the model has changed. This condition catches newly added or any
    // deleted AvailabilityModels
    if (iAvailLength != self.baseAvailability().length) {
      return true;
    }
    else {
      // Otherwise, we need to do a deep inspection against all the models
      // to see if any properties have changed
      for (i = 0; i < iAvailLength; i++) {
        oAvailModel = self.availability()[i];
        oBaseModel = self.baseAvailability()[i];

        // TODO: The following can be rewritten as a single OR expression
        if (oAvailModel.duration() != oBaseModel.duration()) {
          return true;
        }
        else if (oAvailModel.startHour() != oBaseModel.startHour()) {
          return true;
        }
        else if (oAvailModel.startMinute() != oBaseModel.startMinute()) {
          return true;
        }
        else if (oAvailModel.timeZone != oBaseModel.timeZone) {
          return true;
        }
        else if (oAvailModel.recurrenceStart != oBaseModel.recurrenceStart) {
          return true;
        }
        else if (oAvailModel.recurrenceEnd != oBaseModel.recurrenceEnd) {
          return true;
        }
        else if (oAvailModel.dayBitMask() != oBaseModel.dayBitMask()) {
          return true;
        }
        else if (oAvailModel.startDate() != oBaseModel.startDate()) {
          return true;
        }
        else if (oAvailModel.endDate() != oBaseModel.endDate()) {
          return true;
        }
      }
    }

    return false;
  });



	/**
	 * This method requests data from the service
	 *
	 * @method doRequest
	 * @param {Function} fCallback
	 * @return {ResourceWS}
	 */
  self.doRequest = function (fCallback) {
    if (self.resourceId() != null) {
      qcal.setStatusMessage('Requesting resource availability');
      AbstractWS.prototype.doRequest.call(self, fCallback);
    }

    return self;
  };


	/**
	 * This method examines the AvailabilityModels and returns any
	 * that match the dayNum or date (Non-Recurrent Recurrences).
	 *
	 * @method getAvailabilityForDate
	 * @param {Moment} mDate
	 * @return {Array}
	 */
  self.getAvailabilityForDate = function(weekDate) {
    return self.availability().filter(function(availability) {
      var inRecurrenceRange = self.dateInRecurrence(weekDate, availability, resourceWeek());
      var occursOnDay = availability.recurrence().indexOf(weekDate.day().toString()) > -1 && inRecurrenceRange; 
      var occursOnDate = availability.recurrenceType() == "nonRecurrent" && availability.startDate() == weekDate.format("YYYY-MM-DD")
      return (occursOnDay || occursOnDate);
    });
  };


	/**
	 * This method iterates over the baseAvailability() collection and tries to
   * return an AvailabilityModel that matches the ID passed
	 *
	 * @method getBaseAvailabilityById
	 * @param {Integer} iId
	 * @return {AvailabilityModel}
	 */
  self.getBaseAvailabilityById = function (iId) {
    var availability = self.baseAvailability().filter(function (avail) {
      return avail.id === iId;
    });

    return availability.length > 0 ? availability[0] : null;
  };


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into ResourceModels and then assigns
	 * them to this object's resources collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @return {ResourceWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    var aAvails = [];
    var aTemp = [];
    var aBaseTemp = [];
    var mDate = new moment();
    var oBaseModel = null;
    var oModel = null;

    qcal.setStatusMessage('Resource availability received', 1000);

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    self.unavailability.get(self.resourceId(), self.parent.resourceWeek()[0], self.parent.resourceWeek()[6]);

    aAvails = $(xmlData).find('availability').toArray();

    aAvails.forEach(function (avail) {
      oModel = new AvailabilityModel(avail);
      oBaseModel = new AvailabilityModel(avail);

      if (oModel.deleted != true) {
        aTemp.push(oModel);
        aBaseTemp.push(oBaseModel);
      }
    });

    self.availability(aTemp);
    self.baseAvailability(aBaseTemp);

    if (self.availability().length > 0) {
      mDate.hours(self.availability()[0].startHour());
      mDate.minutes(self.availability()[0].startMinute());
    }

    qcal.scrollViewToHour(mDate, true);

    return self;
  };


	/**
   * Removes a specified AvailabilityModel from the working availability()
   * collection
	 *
	 * @method removeAvailability
	 * @param {AvailabilityModel} oAvailabilityModel
	 * @return {ResourceWS}
	 */
  self.removeAvailability = function (oAvailabilityModel) {
    self.availability.remove(oAvailabilityModel);
    return self;
  };


	/**
	 * Resets the object to it's default state
	 *
	 * @method reset
	 * @return {ResourceWS}
	 */
  self.reset = function () {
    self.availability.removeAll();
    self.baseAvailability.removeAll();
    self.resourceId(null);
    self.holidayAdded(false);

    return self;
  };


	/**
   * Resets the availability observabelArray to what was originally
   * received by the service
	 *
	 * @method restore
	 * @return {ResourceWS}
	 */
  self.restore = function () {
    self.processData(self.data);
    return self;
  };


	/**
   * Evaluates the availability() AvailabilityModels against the same in the
   * baseAvailability collection and resolves any differences by passing
   * requests to the UpdateResourceAvailabilityWS
	 *
	 * @method save
	 * @param {Object} data
	 * @param {Event} evt
	 * @return {Boolean} true
	 */
  self.save = function (data, evt) {
    var aAvailIds = [];
    var bModelsMatch = true;
    var oBaseModel = null;

    qcal.updateResourceAvailabilityWS.resourceId(qcal.selectedResource().id);

    // Handle any deletions.
    // This can be easily be determined if the number of AvailabilityModels
    // with IDs are less that the length of the original data returned from the service
    aAvailIds = self.availability().reduce(function (arr, avail) {
      if (avail.id != null) {
        arr.push(avail.id);
      }

      return arr;
    }, []);

    // Now that the number of availabilities with ID has been determined, we
    // can process any deletions, if required
    if (aAvailIds.length < self.baseAvailability().length) {
      // Loop over the original availabilities to find which one(s) were
      // removed. Once found, create a delete request
      self.baseAvailability().forEach(function (avail) {
        if (aAvailIds.indexOf(avail.id) == -1) {
          qcal.updateResourceAvailabilityWS.deleteAvail(avail);
        }
      });
    }

    // Now parse through the current availabilities and determine whether they
    // need to be added, updated, or take no action
    self.availability().forEach(function (avail) {
      // AvailabilityModels with a null ID are new availabilities
      if (avail.id == null) {
        qcal.updateResourceAvailabilityWS.create(avail);
      }

      // If there is an ID, do a comparision inspection of each
      // AvailabilityModel comparing it to the corresponding model in the
      // baseAvailability() collection. If the models don't match, call an
      // update to the model
      else {
        // Grab a copy of the base model for comparison
        oBaseModel = self.getBaseAvailabilityById(avail.id);

        // Now inspect parameters to determine if an update is required
        if (avail.duration() != oBaseModel.duration()) {
          bModelsMatch = false;
        }
        else if (avail.startHour() != oBaseModel.startHour()) {
          bModelsMatch = false;
        }
        else if (avail.startMinute() != oBaseModel.startMinute()) {
          bModelsMatch = false;
        }
        else if (avail.timeZone != oBaseModel.timeZone) {
          bModelsMatch = false;
        }
        else if (avail.recurrenceStart != oBaseModel.recurrenceStart) {
          bModelsMatch = false;
        }
        else if (avail.recurrenceEnd != oBaseModel.recurrenceEnd) {
          bModelsMatch = false;
        }
        else if (avail.dayBitMask() != oBaseModel.dayBitMask()) {
          bModelsMatch = false;
        }
        else if (avail.startDate() != oBaseModel.startDate()) {
          bModelsMatch = false;
        }

        // If the models don't match, call the method to update the mode in the DB
        if (!bModelsMatch) {
          qcal.updateResourceAvailabilityWS.update(avail);
        }
      }
    });

    if (!self.holidayAdded()) {
      qcal.resourceAvailabilitySaved();
    }
  };

  return self;
};

ResourceAvailabilityWS.prototype = AbstractWS.prototype;
ResourceAvailabilityWS.prototype.constructor = ResourceAvailabilityWS;

/**
 * This method examines the current date and tells us if the date is in any availability 
 * range to check if it may be displayed
 *
 * @method dateInRecurrence
 * @param {Moment} weekDate
 * @param {AvailabilityModel} availability
 * @param {Array<Moment>} currentWeek
 * @return {Boolean}
 */
ResourceAvailabilityWS.prototype.dateInRecurrence = function(weekDate, availability, currentWeek) {
  if (availability.recurrenceStart || availability.recurrenceEnd) {
    var recurrenceStart = availability.recurrenceStart ? new moment(availability.recurrenceStart) : new moment(currentWeek[0]);
    var recurrenceEnd = availability.recurrenceEnd ? new moment(availability.recurrenceEnd) : new moment(currentWeek[6]);
    var inRecurrenceRange = weekDate.isBetween(recurrenceStart.add(-1, 'days'), recurrenceEnd.add(1, 'days'));
    return inRecurrenceRange;
  } else {
    return true;
  }
}

if (typeof exports !== 'undefined') {
  exports.ResourceAvailabilityWS = ResourceAvailabilityWS;
}
